/* eslint no-tabs: ["warn", { allowIndentationTabs: true }] */
<template>
  <div>
    <h4 class="text-center mb-5 d-block d-sm-none">
      <slot name="title">Missing Title</slot>
    </h4>
    <div class="d-none d-sm-block">
      <h4 class="ml-2">
        <slot name="title">Missing Title</slot>
      </h4>
      <p class="p-small text-muted mx-2 mt-4 mb-4" :class="{ 'bump-down': countryCode === 'CA' }">
        {{ tradeInRangeText }}
      </p>
    </div>
    <div class="range-container">
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 295 154.3"
        style="enable-background: new 0 0 295 154.3"
        xml:space="preserve"
      >
        <g id="Mobile">
          <g id="XS-AV-Trade-08" transform="translate(-40.000000, -338.000000)">
            <g id="Card" transform="translate(20.000000, 217.000000)">
              <g id="Graph" transform="translate(20.000000, 121.000000)">
                <rect id="Rectangle" x="10.5" y="131.3" class="st0" width="16" height="23" rx="8"></rect>
                <rect x="42.5" y="121.3" class="st0" width="16" height="33" rx="8"></rect>
                <rect x="74.5" y="109.3" class="st1" width="16" height="45" rx="8"></rect>
                <rect x="106.5" y="97.3" class="st1" width="16" height="57" rx="8"></rect>
                <rect x="138.5" y="86.3" class="st1" width="16" height="68" rx="8"></rect>
                <rect x="170.5" y="75.3" class="st1" width="16" height="79" rx="8"></rect>
                <rect x="202.5" y="64.3" class="st1" width="16" height="90" rx="8"></rect>
                <rect x="234.5" y="53.3" class="st0" width="16" height="101" rx="8"></rect>
                <rect x="266.5" y="41.3" class="st0" width="16" height="113" rx="8"></rect>
                <path id="Line" class="st2" d="M210.5,56.3v-24"></path>
                <path class="st2" d="M82.5,101.3v-24"></path>
              </g>
            </g>
          </g>
        </g>
        <rect x="49.5" y="44.4" class="st3" width="58.9" height="15.9"></rect>
        <text id="lowVal" transform="matrix(1 0 0 1 53.5414 64.3627)" class="st4 st5 st6">
          {{ $n(lowPrice, 'currencyDollars', languageCode) }}
        </text>
        <rect x="186.9" y="4.8" class="st3" width="58.2" height="15.9"></rect>
        <text id="highVal" transform="matrix(1 0 0 1 182.9194 18.8084)" class="st4 st5 st6">
          {{ $n(highPrice, 'currencyDollars', languageCode) }}
        </text>
      </svg>
    </div>
    <div class="my-3 d-block d-sm-none">
      <p class="p-small text-muted text-center mx-2 mt-4">{{ tradeInRangeText }}</p>
      <hr class="mt-5" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TradeInSource from '@/utils/enums/tradeInSource';

export default {
  name: 'AverageRange',
  props: {
    lowPrice: {
      type: Number,
      default: 1234,
      required: true,
    },
    highPrice: {
      type: Number,
      default: 5678,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      languageCode: 'user/getLanguageCodeForNumericalInternationalization',
      countryCode: 'business/getBusinessCountry',
    }),
    tradeInRangeText() {
      if (this.$store.state.business.info.tradeInSource === TradeInSource.CARFAX) {
        return this.$t('message.trade.carfaxTradeInRangeText');
      }
      return this.$t('message.trade.tradeInRangeText');
    },
  },
};
</script>

<style scoped lang="scss">
@import 'src/assets/scss/variables';
.card {
  position: relative;
}
.bump-down {
  margin-bottom: 62px;
}
.card-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 45px;
}

.card-body p {
  font-size: 14px;
  font-weight: normal;
}
.range-container {
  position: relative;
  svg {
    .st0 {
      fill-rule: evenodd;
      clip-rule: evenodd;
      fill: #f0f4f7;
    }
    .st1 {
      fill-rule: evenodd;
      clip-rule: evenodd;
      fill: $primary;
    }
    .st2 {
      fill: none;
      stroke: $primary;
      stroke-width: 2;
      stroke-linecap: square;
    }
    .st3 {
      fill: none;
    }
    .st4 {
      fill: $primary;
    }
    .st5 {
      font-family: 'Roboto', sans-serif;
    }
    .st6 {
      font-size: 16px;
    }
  }
}
.graph {
  height: auto;
  display: block;
}
.lowVal {
  position: absolute;
  top: 32%;
  left: 27%;
  height: auto;
}
.highVal {
  position: absolute;
  top: -20px;
  left: 63%;
  height: auto;
}

p {
  font-weight: normal;
}

b {
  text-align: center;
}
</style>
